/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `:host,
* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  contain: content;
  display: inline-block;
  vertical-align: top;
  font-size: calc(12rem/14);
  margin-bottom: calc(8rem/14);
}

.container {
  position: relative;
  display: -webkit-box;
  display: flex;
  height: 100%;
  width: 100%;
  padding: calc(8rem/14) 0 0;
}

.label {
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  position: absolute;
  top: 0;
  left: calc(10rem/14);
  padding: 0 calc(6rem/14);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
  font-size: calc(12rem/14);
  font-weight: 600;
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  pointer-events: none;
}
:host([warning]) .label {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
}
:host([error]) .label {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
}
:not(.focus):not(.hasPlaceholder).valueIsBlank .label {
  top: calc(20rem/14);
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
  font-size: 100%;
  font-weight: normal;
}
:host([disabled]) .label, :host([readonly]) .label, :host([disabled]) :not(.focus):not(.hasPlaceholder).valueIsBlank .label {
  color: #B4BEC5;
  color: var(--davinci-color-outline, #B4BEC5);
}
:host([readonly]) :not(.focus).valueIsBlank .label {
  background-color: transparent;
}

.placeholder {
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  -webkit-transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  transition: all 150ms cubic-bezier(0.4, 0, 0.2, 1);
  position: absolute;
  top: calc(20rem/14);
  left: calc(10rem/14);
  padding: 0 calc(6rem/14);
  font-size: 100%;
  font-weight: normal;
  color: #697987;
  color: var(--davinci-color-text-lighter, #697987);
  pointer-events: none;
  display: none;
}
:host([disabled]) .placeholder {
  color: #B4BEC5;
  color: var(--davinci-color-outline, #B4BEC5);
}
.hasPlaceholder.showPlaceholder .placeholder {
  display: block;
}

div.focus .label {
  color: var(--davinci-color-primary,#007CC1) !important;
}
div.focus textarea {
  border: 1px solid var(--davinci-color-primary,#007CC1) !important;
}
div.focus + .message {
  visibility: hidden;
}

textarea:focus {
  outline: none;
}

textarea {
  background-color: #FFF;
  background-color: var(--davinci-color-background, #FFF);
  color: #323c43;
  color: var(--davinci-color-text, #323c43);
  border-radius: 0;
  -webkit-appearance: none;
  border: 1px solid var(--davinci-color-text-disabled,#8999A4);
  padding: calc(12rem/14) calc(16rem/14);
  font-family: inherit;
  font-size: inherit;
  margin: 0;
  width: 100%;
  height: 100%;
  resize: none;
  overflow: auto;
  pointer-events: all;
}
:host([disabled]) textarea {
  border: 1px solid var(--davinci-color-outline-disabled,#D2D9DD);
  color: #B4BEC5;
  color: var(--davinci-color-outline, #B4BEC5);
  pointer-events: none;
}
:host([readonly]) textarea {
  background-color: #F9FAFB;
  background-color: var(--davinci-color-background-2, #F9FAFB);
  color: #323c43;
  color: var(--davinci-color-text-on-background-2, #323c43);
}
:host([warning]) textarea {
  border: 1px solid var(--davinci-color-warning,#F5C413);
}
:host([error]) textarea {
  border: 1px solid var(--davinci-color-error,#EA0823);
}

textarea::-webkit-scrollbar {
  width: calc(18rem/14);
  background-color: #FFFFFF;
  background-color: var(--davinci-color-white, #FFFFFF);
}

textarea::-webkit-scrollbar-thumb {
  border: calc(6rem/14) solid transparent;
  background-clip: padding-box;
  border-radius: calc(10rem/14);
  background-color: #8999A4;
  background-color: var(--davinci-color-text-disabled, #8999A4);
}

textarea::-webkit-scrollbar-thumb:hover {
  background-color: #697987;
  background-color: var(--davinci-color-text-lighter, #697987);
}

textarea {
  scrollbar-color: var(--davinci-color-text-disabled,#8999A4) var(--davinci-color-white,#FFFFFF);
  scrollbar-width: thin;
}

:host([noresize]) textarea {
  resize: none;
}
:host([noresize]) svg {
  display: none;
}

:host([multiline]) {
  height: calc(120rem/14);
}

.message {
  min-height: calc(18rem/14);
  margin-top: calc(4rem/14);
  font-size: 1rem;
  line-height: calc(18rem/14);
}
.message .warning {
  color: #F5C413;
  color: var(--davinci-color-warning, #F5C413);
  display: none;
}
.message .error {
  color: #EA0823;
  color: var(--davinci-color-error, #EA0823);
  display: none;
}

:host([warning]) .message .error {
  display: none;
}
:host([warning]) .message .warning {
  display: block;
}

:host([error]) .message .error {
  display: block;
}
:host([error]) .message .warning {
  display: none;
}`;
export { style };
//# sourceMappingURL=TextArea.style.js.map